<template>
  <div class="widget white_box">
    <div class="widget_header">
      <div class="location_tag">
        <h3 class="tw-text-neutral-900 tw-text-2xl">
          Local Keyword Rankings
        </h3>
      </div>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        href="/local/gmb/rankings"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons tw-flex tw-gap-2"
      >
        <DefaultButton
          size="small"
          variant="primary-inverted"
          @click="$parent.edit(widget)"
        >
          Options
        </DefaultButton>

        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <div
      v-if="!loading && keywords.length > 0"
      class="table_wrapper"
    >
      <table class="table_component">
        <thead>
          <tr>
            <td style="width: 40%">
              <span>Keyword</span>
            </td>
            <td style="width: 20%">
              <span>Location</span>
            </td>
            <td style="width: 20%">
              <span>Maps</span>
            </td>
            <td style="width: 20%">
              <span>Map Pack</span>
            </td>
          </tr>
        </thead>
      </table>

      <div class="table_body">
        <table class="table_component">
          <tbody>
            <tr
              v-for="(keyword, index) in keywords"
              :key="index"
            >
              <td
                class="keyword"
                style="width: 40%"
              >
                {{ keyword.keyword }}
              </td>
              <td
                class="text-danger"
                style="width: 20%"
              >
                <i class="fas fa-map-marker-alt" />{{ keyword.location }}
              </td>
              <td
                class="volume"
                style="width: 20%"
                v-html="keyword.map"
              />
              <td
                class="volume"
                style="width: 20%"
                v-html="keyword.map_pack"
              />
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <div
        v-if="loading && !error"
        class="loading_widget_data"
      >
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>

      <div
        v-else-if="error"
        class="widget_error"
        v-html="error"
      />

      <div v-else>
        No local keyword rankings
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      keywords: [],
      error: null,
    }
  },
  computed: {
    ...mapState('dashboard', ['uuid', 'preview', 'gmbLocations']),
    selectedLocation() {
      return this.gmbLocations[this.widget.location_id];
    }
  },
  watch: {
    'widget.location_id': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'topLocalKeywords',
        location_id: this.widget.location_id,
        uuid: this.uuid
      }).then(response => {
        this.keywords = response.data;
        this.loading = false;
      }).catch(error => {
        this.error = error.response.data;
        this.loading = false;
      });
    },
  },
}
</script>

<style scoped>
tr td:not(:first-of-type) {
  text-align: center;
}

tr td i {
  margin-right: .5rem;
}

.table_body {
  max-height: 266px;
  overflow-y: auto;
}
</style>
